import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Grid, Dialog, DialogContent,Modal } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import CustomDialog from "../commoncomponents/CustomDialog";
import PageLoader from "../commoncomponents/PageLoader";
import Axios from 'axios';
import { DefaultCard } from "../../assets/styled-components/card";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import PageTitle from "../commoncomponents/PageTitle";
import { MasterGraph, FemsGraph, BemsGraph, ifacSecurityURL } from "../../utility/apiURLS";
import { getAuthToken, getcompanyId, getFacilityId } from "../../utility/tokenUtility";
import Kpiresponsedownloadfile from './Kpiresposedownloadfile';
import { useAccess } from "../../AccessContext";
import DownloadIcon from '@mui/icons-material/Download';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import utilities from '../../utility/utilities';
import * as XLSX from 'xlsx';
// import Kpiresponsedownloadfile from './Kpiresponsedownloadfile';
const Kpiresponseviewfile = () => {
    const ModalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "1200px",
        height: "100%",
        maxHeight: "calc(100% - 64px)",
        bgcolor: "#fff",
        boxShadow: 24,
        borderRadius: "5px",
        p: 4,
        overflowY: "auto",
        overflowX: "hidden",
    };
    
      
    const navigate = useNavigate();
      const[text,setText] = useState("");
    const[date,setDate]=useState("");
    const [service, setService] = useState("");
    const [hospitalname, setHospitalname] = useState("");
    const [options, setOptions] = useState("");
    const [serviceOptions, setServiceOptions] = useState([]);
    const [reportdata, setReportdata] = useState([]);
    const [errors, setErrors] = useState({});
    const [errorMessages, setErrorMessages] = useState({});
    const [year, setYear] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [hospitalnameOptions, setHospitalnameOptions] = useState([]);
    const token = getAuthToken("id_token");
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const [isView, setIsView] = useState(false);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "ENGA009C");

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const filteredOptions = service === 'FEMS'
        ? [
            { label: 'Emergency', value: 2, id: 2 },
            { label: 'Non Emergency', value: 1, id: 1 },
        ]
        : service === 'BEMS'
            ? [
                { label: 'Critical', value: 2, id: 2 },
                { label: 'Non Critical', value: 1, id: 1 },
            ]
            : [];


    // State for the selected option from filtered options
    const [selectedOption, setSelectedOption] = useState(null);

    const userId = localStorage.getItem('UserId');
    const companyId = getcompanyId("companyId");
    const FacilityId = localStorage.getItem('facilityId');

    const handleCancel = () => {
        if (!service || !year || !hospitalnameOptions) {
            navigate("/dashboard");
            dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
            dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
        } else {
            setCancelDialogOpen(true);
        }

    };
    const handlehospital = (newValue) => {
        setHospitalname(newValue?.value || "");
        if (newValue) {
            setHospitalname(newValue);
            setErrors((prevErrors) => ({ ...prevErrors, hospitalname: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, hospitalname: "" }));
            setText("");  // Reset text when hospital changes
            setDate("");  // Reset date when hospital changes
        }
    };

    // const handleServiceChange = (selectedService) => {
    //     setService(selectedService?.value || null);
    //     setOptions(null);


    //     setErrors(prev => ({ ...prev, options: false }));
    //     setErrorMessages(prev => ({ ...prev, options: '' }));
    // };
    const handleServiceChange = (selectedService) => {
        if (selectedService && selectedService.value) {
            // If service is selected, set service and reset options/errors
            setService(selectedService.value);
            setSelectedOption(null);

            // Clear any existing errors for both service and options
            setErrors(prev => ({ ...prev, service: false, options: false }));
            setErrorMessages(prev => ({ ...prev, service: '', options: '' }));
           
        } else {
            // If service is not selected, trigger service validation error
            setService(null);
            setSelectedOption(null);

            setErrors(prev => ({ ...prev, service: true }));
            setErrorMessages(prev => ({ ...prev, service: "Service is required" }));
            setText("");  // Reset text when hospital changes
            setDate("");  // Reset date when hospital changes
        }
    };

    const handleOptionsChange = (selectedOption) => {
        setSelectedOption(selectedOption);

        if (service) { // Only validate options if a service is selected
            if (selectedOption) {
                // Clear option error if valid option is selected
                setErrors((prevErrors) => ({ ...prevErrors, options: false }));
                setErrorMessages((prevErrorMessages) => ({ ...prevErrorMessages, options: "" }));
            } else {
                // Set option error if no option is selected
                setErrors((prevErrors) => ({ ...prevErrors, options: true }));
                setErrorMessages((prevErrorMessages) => ({ ...prevErrorMessages, options: "Option is required" }));
            }
        }
        setText("");  // Reset text when hospital changes
        setDate("");  // Reset date when hospital changes
    };


    const handleYearChange = (newValue) => {
        setYear(newValue?.value || "");
        if (newValue) {
            setErrors((prevErrors) => ({ ...prevErrors, year: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, year: "" }));
            setText("");  // Reset text when hospital changes
            setDate("");  // Reset date when hospital changes
        }

    };


    const fetchServiceOptions = async () => {
        try {
            const response = await Axios.get(`${MasterGraph}/api/masservicedetails`, config);
            const filteredOptions = response.data.filter(option => option.service);
            setServiceOptions(filteredOptions.map(option => ({
                label: option.service,
                value: option.service,
                id: option.id
            })));

        } catch (error) {

        }
    };

    const fetchHospitalName = async () => {
        try {
            const response = await Axios.get(`${ifacSecurityURL}/api/GraphUserdetails/GetAllFacilityDetailsByCompanyIdAndUserId/${companyId}/${userId}`, config);
            if (response.data && Array.isArray(response.data)) {
                const options = response.data.map((hn) => ({
                    label: hn.facilityName,
                    id: hn.facilityId,
                }));
                setHospitalnameOptions(options);

            }
        } catch (error) {

        }
    };



    const fetchReportdata = async () => {
        try {
            let response;


            if (!selectedOption.id) {
                console.error("ID not found for the selected option. Please check the options and filteredOptions.");
                return;
            }
            if (service === "FEMS") {
                response = await Axios.get(`${FemsGraph}/GetKPIResponseTime/${year}/${selectedOption.id}/${hospitalname.id}?size=1000`, config);
            } else if (service === "BEMS") {
                response = await Axios.get(`${BemsGraph}/GetKPIResponseTime/${year}/${selectedOption.id}/${hospitalname.id}?size=1000`, config);
            } else {
                return;
            }

            const reportdata = Array.isArray(response.data) ? response.data[0] : response.data;
            setReportdata(reportdata);


        } catch (error) {
            console.log("Error fetching report data:", error);
        }
    };
    useEffect(() => {
        fetchReportdata();
        fetchServiceOptions();
        fetchHospitalName();
    }, []);

    const handleView = async () => {
        setIsView(true);

        // Check if Service and Options are selected
        const isServiceSelected = !!service; // Check if service is selected
        const isOptionSelected = isServiceSelected ? !!selectedOption : true; // Validate options only if service is selected

        // Validate all fields including options (only if service is selected)
        if (!service || !year || !hospitalname || !isOptionSelected) {
            setErrors({
                service: !service,
                year: !year,
                hospitalname: !hospitalname,
                options: isServiceSelected && !selectedOption // Show error for options only if service is selected
            });

            setErrorMessages({
                service: !service ? "Service is required" : "",
                year: !year ? "Year is required" : "",
                hospitalname: !hospitalname ? "Hospital Name is required" : "",
                options: isServiceSelected && !selectedOption ? "Option is required" : "" // Show message only if service is selected and no option is selected
            });

            return; // Stop execution if validation fails
        }
        // setLoading(true);
        try {
           
            await fetchReportdata();
            setOpenModal(true);
        } catch (error) {


        }
        // finally {
        //     setLoading(false);
        // }
    }; 
    const handleDownload = async () => {
        if (!service || !year || !hospitalname || !selectedOption) {
            setErrors({
                service: !service,
                year: !year,
                hospitalname: !hospitalname,
                options: !selectedOption
            });
    
            setErrorMessages({
                service: !service ? "Service is required" : "",
                year: !year ? "Year is required" : "",
                hospitalname: !hospitalname ? "Hospital Name is required" : "",
            });
            return;
        }
    
        try {
          await fetchReportdata();
            setIsView(false);
            setOpenModal(true);
    
            setTimeout(() => {
                if (childRef.current) {
                    childRef.current.handleDownloadPDF();
                }
    
                setTimeout(() => {
                    setOpenModal(false);
                }, 1000);
            }, 500);
        } catch (error) {
            console.error("Error fetching report data:", error);
        } 
    };
    
    const handleExcel = async () => {
        if (!service || !year || !hospitalname || !selectedOption) {
            setErrors({
                service: !service,
                year: !year,
                hospitalname: !hospitalname,
                options: !selectedOption
            });

            setErrorMessages({
                service: !service ? "Service is required" : "",
                year: !year ? "Year is required" : "",
                hospitalname: !hospitalname ? "Hospital Name is required" : "",

            });
            return;
        }
        try {
            setLoading(true);
        await fetchReportdata();
        setIsView(false);
        setOpenModal(true);

        setTimeout(() => {
            if (childRef.current) {
                childRef.current.handleExcel();
            }

            setTimeout(() => {
                setOpenModal(false);
            }, 1000);
        }, 500);
    } catch (error) {
        console.error("Error fetching report data:", error);
    } finally {
        setLoading(false);
    }


    };
  

    const handleCancelConfirm = () => {
        setCancelDialogOpen(false);
        navigate("/dashboard");
        dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
        dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
    };
    const handleCancelDialogClose = () => {
        setCancelDialogOpen(false);
    };

   
    return (
        <>
               <PageLoader open={loading} />
            <PageTitle title={"KPI Response  Time Report"} />

            <Box mt={{ xs: 1, sm: 2 }}>
                <DefaultCard>
                    <Grid container spacing={2}>

                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Hospital Name"
                                id="hospital-name"
                                autoFocus={true}
                                value={hospitalname || null}
                                options={hospitalnameOptions}
                                onChange={handlehospital}
                                isMandatoryField={true}
                                error={errors.hospitalname}
                                errorMessage={errorMessages.hospitalname}
                            />

                        </Grid>
                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Service"
                                value={serviceOptions.find(option => option.value === service) || null}
                                options={serviceOptions}
                                onChange={handleServiceChange}
                                isMandatoryField={true}
                                error={errors.service}
                                errorMessage={errorMessages.service}
                            />
                        </Grid>
                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Options"
                                value={selectedOption || null}
                                options={filteredOptions}
                                onChange={handleOptionsChange}
                                isMandatoryField={true}
                                error={errors.options}
                                errorMessage={errorMessages.options}
                                disabled={!service} // Options are disabled until a service is selected
                            />
                        </Grid>



                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Year"
                                name="Year"
                                value={year ? { label: year.toString(), value: year } : null}
                                options={[
                                    { label: `${new Date().getFullYear()}`, value: new Date().getFullYear() },
                                    { label: `${new Date().getFullYear() - 1}`, value: new Date().getFullYear() - 1 },
                                ]}
                                onChange={handleYearChange}
                                isMandatoryField={true}
                                error={errors.year}
                                errorMessage={errorMessages.year}
                            />

                        </Grid>

                    </Grid>

                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            justifyContent: { xs: "center", md: "end" },
                            mt: 3,
                        }}
                    >
                        <Button variant='contained' onClick={handleView}>View</Button>
                        {access?.canPrint && <Button variant='contained'
                         startIcon={<DownloadIcon />}  
                         style={{ marginRight: '8px' }} onClick={handleDownload}>PDF</Button>}
                        <Button variant='contained' onClick={handleExcel}
                        startIcon={<InsertDriveFileIcon />} 
                        style={{ marginRight: '8px' }}>XLSX</Button>
                        <Button variant='outlined' onClick={handleCancel}>Close</Button>
                    </Box>
                </DefaultCard>
                <Modal
                open={openModal}
                sx={
                    !isView && {
                        "& .MuiBackdrop-root": {
                            backgroundColor: "transparent",
                        },
                        top: "-9999px",
                        left: "-9999px",
                        zIndex: "-1",
                    }
                }
            >
                       <Box sx={ModalStyle}>
                        <Kpiresponsedownloadfile
                            reportdata={reportdata}
                            setOpenModal={setOpenModal}
                            hospitalname={hospitalname}
                            year={year}
                            options={selectedOption}
                            service={service}
                            ref={childRef}
                             text={text}
                            setText={setText}
                            date={date}
                            setDate={setDate}
                        />
                   </Box>
                </Modal>
            </Box>
            <CustomDialog
                open={cancelDialogOpen}
                onClose={handleCancelDialogClose}
                onConfirm={handleCancelConfirm}
                title="Cancel Confirmation"
                content="Do you want to continue?"
                cancelBtn="No"
                confirmBtn="Yes"
            />
        </>
    );
};

export default Kpiresponseviewfile;
